import { Box, Text } from '@bonanza-social/moonlight';

function WelcomeContent() {
  return (
    <Box padding="space-200">
      <Text variant="body-m-semi" color="darkSurfacePrimary">
        Welcome Bonus
      </Text>
    </Box>
  );
}

export default WelcomeContent;
